module.exports = __webpack_public_path__ + "static/apple-icon-120x120-20182f9e360ce10ae25e783a4e65168d.png";